import type LabelFormat from '~/types/LabelFormat';

import { ActionKeys } from '~/actions/constants';
import { type ActionTypes } from '~/actions/index';
import { DefaultLabelFormat } from '~/types/LabelFormat';
import PackingSlipFormat from '~/types/PackingSlipFormat';

export type LabelSettingsState = {
  readonly data: Readonly<{
    readonly defaultLabelFormat: LabelFormat;
    readonly defaultOutboundAccount: null | string;
    readonly defaultPackingSlipFormat: PackingSlipFormat;
    readonly defaultReturnAccount: null | string;
    readonly isAutoCreateReturnLabels: boolean;
    readonly isMergeLabelsAndPackingSlips: boolean;
    readonly isRequireSignatureConfirmation: boolean;
    readonly isUseOrderNumber: boolean;
    readonly labelLogoType: Maybe<string>;
    readonly outboundFallbackAccount?: null | string;
    readonly outboundFallbackServiceLevel?: null | string;
    readonly outboundReturnLabelServiceLevel: string;
    readonly outboundServiceLevel: string;
    readonly packingSlipShowPrices: boolean;
    readonly packingSlipText: string;
    readonly refText1: string;
    readonly refText2: string;
    readonly storePolicyText: string;
  }>;
  readonly isLoadedLabelSettings: boolean;
};

const labelSettingsInitialState: LabelSettingsState = {
  data: {
    defaultLabelFormat: DefaultLabelFormat,
    defaultOutboundAccount: null,
    defaultPackingSlipFormat: PackingSlipFormat.PSLIP_8X11_PDF,
    defaultReturnAccount: null,
    isAutoCreateReturnLabels: false,
    isMergeLabelsAndPackingSlips: false,
    isRequireSignatureConfirmation: false,
    isUseOrderNumber: false,
    labelLogoType: null,
    outboundReturnLabelServiceLevel: '',
    outboundServiceLevel: '',
    packingSlipShowPrices: true,
    packingSlipText: '',
    refText1: '',
    refText2: '',
    storePolicyText: '',
  },
  isLoadedLabelSettings: false,
};

const labelSettingReducer = (
  state: LabelSettingsState = labelSettingsInitialState,
  action: ActionTypes,
): LabelSettingsState => {
  switch (action.type) {
    case ActionKeys.SAVE_LABEL_SETTINGS_SUCCESS:
      return {
        ...state,
        data: {
          defaultLabelFormat: action.payload.defaultLabelFormat,
          defaultOutboundAccount: action.payload.defaultOutboundAccount,
          defaultPackingSlipFormat: action.payload.defaultPackingSlipFormat,
          defaultReturnAccount: action.payload.defaultReturnAccount,
          isAutoCreateReturnLabels: action.payload.isAutoCreateReturnLabels,
          isMergeLabelsAndPackingSlips: action.payload.isMergeLabelsAndPackingSlips,
          isRequireSignatureConfirmation: action.payload.isRequireSignatureConfirmation,
          isUseOrderNumber: action.payload.isUseOrderNumber,
          labelLogoType: action.payload.labelLogoType,
          outboundFallbackAccount: action.payload.outboundFallbackAccount,
          outboundFallbackServiceLevel: action.payload.outboundFallbackServiceLevel,
          outboundReturnLabelServiceLevel: action.payload.outboundReturnLabelServiceLevel,
          outboundServiceLevel: action.payload.outboundServiceLevel,
          packingSlipShowPrices: action.payload.packingSlipShowPrices,
          packingSlipText: action.payload.packingSlipText,
          refText1: action.payload.refText1,
          refText2: action.payload.refText2,
          storePolicyText: action.payload.storePolicyText,
        },
      };
    case ActionKeys.FETCH_LABEL_SETTINGS:
      return {
        ...state,
        isLoadedLabelSettings: false,
      };
    case ActionKeys.FETCH_LABEL_SETTINGS_SUCCESS:
      return {
        ...state,
        data: {
          defaultLabelFormat: action.payload.defaultLabelFormat,
          defaultOutboundAccount: action.payload.defaultOutboundAccount,
          defaultPackingSlipFormat: action.payload.defaultPackingSlipFormat,
          defaultReturnAccount: action.payload.defaultReturnAccount,
          isAutoCreateReturnLabels: action.payload.isAutoCreateReturnLabels,
          isMergeLabelsAndPackingSlips: action.payload.isMergeLabelsAndPackingSlips,
          isRequireSignatureConfirmation: action.payload.isRequireSignatureConfirmation,
          isUseOrderNumber: action.payload.isUseOrderNumber,
          labelLogoType: action.payload.labelLogoType,
          outboundFallbackAccount: action.payload.outboundFallbackAccount,
          outboundFallbackServiceLevel: action.payload.outboundFallbackServiceLevel,
          outboundReturnLabelServiceLevel: action.payload.outboundReturnLabelServiceLevel,
          outboundServiceLevel: action.payload.outboundServiceLevel,
          packingSlipShowPrices: action.payload.packingSlipShowPrices,
          packingSlipText: action.payload.packingSlipText,
          refText1: action.payload.refText1,
          refText2: action.payload.refText2,
          storePolicyText: action.payload.storePolicyText,
        },
        isLoadedLabelSettings: true,
      };
    default:
      return state;
  }
};

export default labelSettingReducer;
